interface ICreateDeveloperProductArguments {
  id: number;
  offerType?: string;
}

export function createDeveloperProduct({ id, offerType = 'builder' }: ICreateDeveloperProductArguments) {
  return { id, offerType };
}
